import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.auditFLow.getList, {
        search,
        count,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
